import { CtaBlock } from '@design-system/cta-block';
import { PageBlock } from '@design-system/page-block';
import React, { forwardRef } from 'react';

import { Carousel } from '../ItemListingCarousel';
import { ItemListingCarouselProps } from '../models';

export const ItemListingRails = forwardRef<
  HTMLDivElement,
  ItemListingCarouselProps
>(({ pageBlock, carousel, id, showMore, uid, fancySlider }, ref) => {
  const carouselBlockClass = fancySlider
    ? `item-listing-rails-block fancy-slider`
    : `item-listing-rails-block`;

  return (
    <PageBlock
      {...pageBlock}
      className={carouselBlockClass}
      id={id}
      componentUid={uid}
      ref={ref}
    >
      <Carousel
        {...carousel}
        ariaLivePlaceholder={(activeIndex, totalCount) =>
          `Show ${activeIndex} of ${totalCount}`
        }
      />
      {showMore ? (
        <CtaBlock
          className="item-listing-rails-block__button"
          button
          align="center"
          {...showMore}
        />
      ) : null}
    </PageBlock>
  );
});

export default ItemListingRails;
